module.exports = require("pem-ts");